import { Modal } from 'antd';
import FormItem from 'antd/es/form/FormItem';
import React, { ReactElement, useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Dispatch } from 'redux';
import ILoanDrawdown from '~Api/Loan/ILoanDrawdown';
import ILoanDrawdownCondition from '~Api/LoanDrawdowns/ILoanDrawdownCondition';
import { loanDrawdownConditionsAddAction } from '~LoanDrawdowns/actions';
import Input from '~UI/Input';

interface IDrawdownConditionAddModalErrors {
    conditionName?: string;
}

export default function ConditionAddModal(props: {
    loanDrawdown: ILoanDrawdown;
    isOpen: boolean;
    onCancel: () => void;
}): ReactElement {
    const {
        loanDrawdown,
        isOpen,
        onCancel,
    } = props;

    const [ conditionName, setConditionName ] = useState<string>(null);
    const [ errors, setErrors ] = useState<IDrawdownConditionAddModalErrors>({});

    const dispatch: Dispatch = useDispatch();

    const onChangeConditionName: (event: React.ChangeEvent<HTMLInputElement>) => void = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
        setConditionName(event.target.value);
    }, []);

    const validateConditionName: () => boolean = useCallback(() => {
        let error: string;

        if (!conditionName || conditionName.length === 0) {
            error = 'Please enter the name';
        }

        setErrors((prevErrors: IDrawdownConditionAddModalErrors) => ({
            ...prevErrors,
            conditionName: error,
        }));

        return !error;
    }, [
        conditionName,
    ]);

    const onClickAdd: () => void = useCallback(() => {
        const valid: boolean = validateConditionName();

        if (!valid) {
            return;
        }

        const loanDrawdownCondition: ILoanDrawdownCondition = {
            loanDrawdownUuid: loanDrawdown.uuid,
            name: conditionName,
        };
        dispatch(loanDrawdownConditionsAddAction(loanDrawdown.uuid, loanDrawdownCondition));

        setConditionName(null);
        onCancel();
    }, [
        conditionName,
        dispatch,
        loanDrawdown.uuid,
        onCancel,
        validateConditionName,
    ]);

    return (
        <Modal
            destroyOnClose={true}
            okText='Add Condition'
            onCancel={onCancel}
            onOk={onClickAdd}
            open={isOpen}
            title={`Add Condition for Drawdown ${loanDrawdown.drawdownNumber}`}
            width={600}
            wrapClassName='loan-drawdown-condition-add-modal'
        >
            <FormItem
                help={errors.conditionName}
                label='Name'
                validateStatus={errors.conditionName && 'error'}
            >
                <Input
                    maxLength={255}
                    onBlur={validateConditionName}
                    onChange={onChangeConditionName}
                    value={conditionName}
                    showCount={true}
                />
            </FormItem>
        </Modal>
    );
}

